import { actionCreatorFactory } from 'typescript-fsa';
import { RuleValidity, RuleStatus } from '@cbridge-tools/rules-data-grid';
import { IRuleValidationResult } from '@cbridge-packages/rule';
import { IRulesManagementState, RowsComparator, IPermittedRuleRowModel } from './rulesManagement.interface';

export namespace RulesManagementAction {
  const actionCreator = actionCreatorFactory('RulesManagement');

  export const updateState = actionCreator<IRulesManagementState>('UPDATE_STATE');
  export const toggleStatusFilter = actionCreator<RuleStatus>('TOGGLE_STATUS_FILTER');
  export const toggleValidityFilter = actionCreator<RuleValidity>('TOGGLE_VALIDITY_FILTER');
  export const beginEditing = actionCreator<{ emptyRowModel?: IPermittedRuleRowModel }>('BEGIN_EDITING');
  export const endEditing = actionCreator<IRulesManagementState | undefined>('END_EDITING');
  export const setHasErrors = actionCreator<{ id: IPermittedRuleRowModel['id']; invalid: boolean }>('SET_HAS_ERRORS');

  export const addRule = actionCreator<{ index: number; emptyRowModel?: IPermittedRuleRowModel }>('ADD_RULE');
  export const removeRule = actionCreator<{ index: number }>('REMOVE_RULE');
  export const restoreRule = actionCreator<{ index: number }>('RESTORE_RULE');
  export const updateRule = actionCreator<{ updatedRule: IPermittedRuleRowModel; isEqualsToOriginal: RowsComparator }>('UPDATE_RULE');
  export const reorderRule = actionCreator<{ targetIndex: number; oldIndex: number; isEqualsToOriginal: RowsComparator }>('REORDER_RULE');
  export const applyValidation = actionCreator<IRuleValidationResult[]>('APPLY_VALIDATION');
  export const resetValidityFilter = actionCreator('RESET_VALIDITY_FILTER');
  export const toggleFilterMode = actionCreator('TOGGLE_FILTER_MODE');
  export const init = actionCreator<{ settingsKey?: string }>('INIT');
  export const setSidebarOpen = actionCreator<boolean>('SET_SIDEBAR_OPEN');
  /** Explicit user open/close of the details sidebar; written to the profile (programmatic closes are not). */
  export const persistSidebarOpen = actionCreator<boolean>('PERSIST_SIDEBAR_OPEN');
  export const setFilteredCount = actionCreator<number>('SET_FILTERED_COUNT');

  export const destroy = actionCreator('DESTROY');
}
